import { z } from 'zod';

export enum AssignedCategoryFormKeys {
    assignedResourceCategoryId = 'assignedResourceCategoryId',
    updatePrice = 'updatePrice',
    updateRequestedCategory = 'updateRequestedCategory',
}

export const AssignedCategoryFormSchema = z.object({
    [AssignedCategoryFormKeys.assignedResourceCategoryId]: z.string(),
    [AssignedCategoryFormKeys.updatePrice]: z.boolean(),
    [AssignedCategoryFormKeys.updateRequestedCategory]: z.boolean(),
});

export type AssignedCategoryFormValues = z.infer<typeof AssignedCategoryFormSchema>;
